import PictureInput from '../components/form/PictureInput';
import NationalityModel from '../models/NationalityModel';
import TranslatableInput from '../components/form/TranslatableInput';
import { FlagIcon } from '../components/Icons';

export default {
    baseUrl: '/countries',
    icon: FlagIcon,
    roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
    titles: {
        list: 'Countries',
        create: 'Add a new country',
        update: 'Update country',
        delete: 'Delete country',
    },
    calls: {
        list: NationalityModel.list,
        create: NationalityModel.create,
        update: NationalityModel.edit,
        delete: NationalityModel.remove,
        read: NationalityModel.read
    },
    list: {
        displayedColumns: [
            {
                field: 'name',
                title: 'Name'
            }
        ],
        paginate: false
    },
    form: {
        blocks: [
            [
                {
                    component: PictureInput,
                    field: 'picture',
                    props: {
                        label: 'Picture'
                    },
                    externalObjectProps: {
                        placeholderPicture: 'picture.displayPath'
                    },
                    defaultValue: null
                }
            ],
            [
                {
                    component: TranslatableInput,
                    field: 'name',
                    props: {
                        label: 'Name',
                        multiline: false
                    },
                    defaultValue: []
                }
            ]
        ]
    }
}
